/* Kleiner Markdown-Renderer fuer Skripte (Ueberschriften, Absaetze, Listen,
   Tabellen, Zitate, **fett**, *kursiv*, `code`). Bewusst ohne Bibliothek und
   ohne HTML-Durchreichung: Der Text kommt aus einer Datei im Repo. */
import { Fragment } from 'react';

function inline(text, key) {
  const teile = [];
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g;
  let letzte = 0; let m; let i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > letzte) teile.push(text.slice(letzte, m.index));
    const t = m[0];
    if (t.startsWith('**')) teile.push(<strong key={`${key}-${i++}`}>{t.slice(2, -2)}</strong>);
    else if (t.startsWith('`')) teile.push(<code key={`${key}-${i++}`} className="px-1 rounded bg-muted text-[0.9em]">{t.slice(1, -1)}</code>);
    else teile.push(<em key={`${key}-${i++}`}>{t.slice(1, -1)}</em>);
    letzte = m.index + t.length;
  }
  if (letzte < text.length) teile.push(text.slice(letzte));
  return teile;
}

export default function Markdown({ text, className = '' }) {
  const zeilen = (text || '').replace(/\r\n/g, '\n').split('\n');
  const bloecke = [];
  let i = 0;
  while (i < zeilen.length) {
    const z = zeilen[i];
    if (!z.trim()) { i++; continue; }
    const h = z.match(/^(#{1,4})\s+(.*)$/);
    if (h) {
      const Tag = `h${Math.min(h[1].length + 1, 5)}`;
      const cls = { h2: 'text-lg font-extrabold mt-2', h3: 'text-sm font-bold mt-4', h4: 'text-sm font-semibold mt-3', h5: 'text-xs font-semibold mt-2' }[Tag];
      bloecke.push(<Tag key={i} className={cls}>{inline(h[2], i)}</Tag>);
      i++; continue;
    }
    if (z.startsWith('>')) {
      const zeilenZitat = [];
      while (i < zeilen.length && zeilen[i].startsWith('>')) { zeilenZitat.push(zeilen[i].replace(/^>\s?/, '')); i++; }
      bloecke.push(<blockquote key={i} className="border-l-2 border-amber-400 bg-amber-50 dark:bg-amber-900/20 px-3 py-2 text-xs rounded-r">{zeilenZitat.map((q, j) => <Fragment key={j}>{inline(q, `${i}-${j}`)}{j < zeilenZitat.length - 1 && <br />}</Fragment>)}</blockquote>);
      continue;
    }
    if (z.trim().startsWith('|')) {
      const rows = [];
      while (i < zeilen.length && zeilen[i].trim().startsWith('|')) { rows.push(zeilen[i]); i++; }
      const zellen = (r) => r.trim().replace(/^\||\|$/g, '').split('|').map(c => c.trim());
      const kopf = zellen(rows[0]);
      const body = rows.slice(1).filter(r => !/^\|?\s*:?-{2,}/.test(r.trim())).map(zellen);
      bloecke.push(
        <table key={i} className="w-full text-xs my-2 border border-border/60">
          <thead className="bg-muted/40"><tr>{kopf.map((c, j) => <th key={j} className="px-2 py-1 text-left font-semibold">{inline(c, `${i}-h${j}`)}</th>)}</tr></thead>
          <tbody>{body.map((r, ri) => <tr key={ri} className="border-t border-border/40">{r.map((c, j) => <td key={j} className="px-2 py-1 align-top">{inline(c, `${i}-${ri}-${j}`)}</td>)}</tr>)}</tbody>
        </table>);
      continue;
    }
    if (/^\s*([-*]|\d+\.)\s+/.test(z)) {
      const items = []; const nummeriert = /^\s*\d+\./.test(z);
      while (i < zeilen.length && /^\s*([-*]|\d+\.)\s+/.test(zeilen[i])) { items.push(zeilen[i].replace(/^\s*([-*]|\d+\.)\s+/, '')); i++; }
      const Tag = nummeriert ? 'ol' : 'ul';
      bloecke.push(<Tag key={i} className={`${nummeriert ? 'list-decimal' : 'list-disc'} pl-5 space-y-0.5 text-sm`}>{items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}</Tag>);
      continue;
    }
    const absatz = [];
    while (i < zeilen.length && zeilen[i].trim() && !/^(#{1,4}\s|>|\||\s*([-*]|\d+\.)\s)/.test(zeilen[i])) { absatz.push(zeilen[i]); i++; }
    bloecke.push(<p key={i} className="text-sm leading-relaxed">{absatz.map((a, j) => <Fragment key={j}>{inline(a, `${i}-${j}`)}{j < absatz.length - 1 && ' '}</Fragment>)}</p>);
  }
  return <div className={`space-y-2 ${className}`}>{bloecke}</div>;
}
